import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import { CalendarDays, Inbox, KanbanSquare, ListTodo, MailPlus, MessageCircle, MessagesSquare, MoonStar, Send, Sun, TicketCheck, Users } from "lucide-react";
import { WorkspaceMenubar as ShellMenubar, type MenubarGroup } from "@/ui";
import { useMailUnreadCount } from "@/lib/use-mail-unread-count";

const groups: readonly MenubarGroup[] = [
    { label: "Mail", destinations: [
        { label: "Inbox", path: "/inbox", icon: Inbox },
        { label: "Sent", path: "/sent", icon: Send },
        { label: "Drafts", path: "/drafts", icon: MailPlus },
        { label: "Templates", path: "/templates", icon: MailPlus },
    ] },
    { label: "Chat", destinations: [
        { label: "Conversations", path: "/chat", icon: MessageCircle },
        { label: "Cases", path: "/cases", icon: TicketCheck },
    ] },
    { label: "Sales", settings: { path: "/settings/sales" }, destinations: [
        { label: "Pipeline", path: "/pipeline", icon: KanbanSquare },
        { label: "Contacts", path: "/contacts", icon: Users },
        { label: "Companies", path: "/companies", icon: Users },
        { label: "Events", path: "/events", icon: CalendarDays },
    ] },
    { label: "Workday", settings: { path: "/settings/calendar" }, destinations: [
        { label: "Today", path: "/today", icon: Sun },
        { label: "Tasks", path: "/actions", icon: ListTodo },
        { label: "Going quiet", path: "/quiet", icon: MoonStar },
        { label: "Calendar", path: "/calendar", icon: CalendarDays },
        { label: "Meetings", path: "/meetings", icon: MessagesSquare },
    ] },
];

/** Kardoe OS menubar: the shared shell menubar fed with CRM destinations and the live unread count. */
export function WorkspaceMenubar() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const unreadCount = useMailUnreadCount();
    const withCounts = useMemo(() => groups.map(group => group.label !== "Mail" ? group : {
        ...group,
        count: unreadCount,
        destinations: group.destinations.map(item => item.path === "/inbox" ? { ...item, count: unreadCount } : item),
    }), [unreadCount]);
    return <ShellMenubar groups={withCounts} pathname={pathname} onNavigate={navigate} ariaLabel="Kardoe OS" />;
}
